import KEY_EXPORT_USER_REPORT_QUERY from 'graph/reports/key-export-user-report-query';
import { ReportWorkbook, ReportEntityType } from 'components/ReportsModule/types';
import { DocumentType } from 'types/__generated__/gql';
import { STUDENT_WORKSHEETS } from './student';

type EducatorExport = DocumentType<typeof KEY_EXPORT_USER_REPORT_QUERY>;

export const EDUCATOR_WORKBOOK: ReportWorkbook<EducatorExport> = {
  query: KEY_EXPORT_USER_REPORT_QUERY,
  async: true,
  isComplete: data => {
    const subqueryResponses = [data.classrooms, data.students];
    return subqueryResponses.every(response => !!response.result);
  },
  getEntityName: (data): string => `${data.user?.firstName} ${data.user?.lastName}`,
  worksheets: [
    {
      name: ReportEntityType.USER,
      parseQueryData: data => mapEducatorWorksheet(data)
    },
    ...STUDENT_WORKSHEETS.map(worksheet => ({
      ...worksheet,
      parseQueryData: (data: EducatorExport, reportParams: any) =>
        worksheet.parseQueryData({ students: data?.students?.result }, reportParams)
    }))
  ]
};

const mapEducatorWorksheet = (data: EducatorExport): any[] => {
  const educator = data.user;

  if (!data.classrooms?.result) return [];

  const classrooms = data.classrooms?.result;

  return classrooms.map((classroom: any) => ({
    classroomName: classroom.classroom?.name,
    classroomSisId: classroom.classroom?.sisId,
    educator: `${educator?.firstName} ${educator?.lastName}`,
    educatorSisId: educator?.sisId,
    organization: classroom.classroom?.organization?.name,
    studentCount: classroom.totalStudentCount,
    activeStudents: classroom.activeStudentCount,
    assignedLicenses: classroom.classroom?.licenseUsage
      ?.map((usage: any) => usage.assignedCount)
      .reduce((a: any, b: any) => a + b, 0),
    overallCurriculumProgress: classroom.curriculumProgressPercentage,
    activitiesCompletedTotal: classroom.totalActivitiesCompletedCount,
    averageWeeklyTimeSpentTotal: classroom.averageWeeklyMinutesSpent
  }));
};
